export function useRegionReady() {
  const directoryStore = useDirectoryStore()
  const isReady = computed(() => !!directoryStore.regionId)

  /**
   * Ждёт, пока regionId станет валидным.
   * Если уже валиден — резолвится сразу.
   */
  const untilReady = (): Promise<void> => {
    if (isReady.value) return Promise.resolve()

    return new Promise<void>((resolve) => {
      const stop = watch(isReady, (val) => {
        if (val) {
          stop()
          resolve()
        }
      })
    })
  }

  return { isReady, untilReady }
}
